module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "platform"
  }, [_c('com-title', {
    attrs: {
      "title": "我们的营销平台",
      "subtitle": "覆盖1000万+中高端技术人员"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-tech container"
  }, [_c('div', {
    staticClass: "section-media"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("技术媒体")]), _vm._v(" "), _c('ul', {
    staticClass: "content columns"
  }, _vm._l((_vm.medias), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item column"
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "slogan"
    }, [_vm._v(_vm._s(item.slogan))])])])
  }))]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "section-video"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("视频品牌")]), _vm._v(" "), _c('ul', {
    staticClass: "content columns"
  }, _vm._l((_vm.videosM), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item column"
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "slogan"
    }, [_vm._v(_vm._s(item.slogan))])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "section-video mobile"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("视频品牌")]), _vm._v(" "), _c('ul', {
    staticClass: "content columns"
  }, _vm._l((_vm.videosM), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item column"
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "slogan"
    }, [_vm._v(_vm._s(item.slogan))])])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section-wechat container"
  }, [_c('h3', [_vm._v("垂直公众号")]), _vm._v(" "), _c('ul', {
    staticClass: "columns is-mobile"
  }, _vm._l((_vm.wechats), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-half-mobile"
    }, [_c('div', {
      staticClass: "wrap"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "intro"
    }, [_c('img', {
      attrs: {
        "src": item.qcode,
        "alt": ""
      }
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "section-conf container"
  }, [_c('h3', [_vm._v("技术大会")]), _vm._v(" "), _c('ul', {
    staticClass: "columns is-mobile"
  }, _vm._l((_vm.confs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third-desktop"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-084f6592","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/market/platform.vue
// module id = 435
// module chunks = 1